import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { PUBLIC_KEY } from '../../utils/EditorToolbar';
import { useFlutterwave } from 'flutterwave-react-v3';
import { updateOrder, saveOrders } from '../../services/paymentService';
import { notification } from 'antd';

import { useNavigate } from 'react-router';
import Header from '../../components/Header/Header';
import Button from '../../components/Button/Button';
import ReactPixel from 'react-facebook-pixel';

const Cart = () => {
  const navigate = useNavigate();

  useEffect(() => {
    ReactPixel.pageView(); // Track a page view event
  }, []);

  let sCart = JSON.parse(localStorage.getItem('cart'));
  let values = JSON.parse(localStorage.getItem('userData'));
  let token = localStorage.getItem('token');
  let courseids = sCart ? sCart?.map((el) => Number(el.id)) : [];
  const [reference, setReference] = useState('');
  const [loading, setLoading] = useState(false);
  const [cartItems, setCartItems] = useState(sCart || []);

  useEffect(() => {
    setReference(`PL-EDV${Date.now()}${Math.floor(Math.random() * 10 + 1)}`);
  }, []);

  const removeItem = (id) => {
    let filtered = cartItems.filter((el) => el.id !== id);
    setCartItems(filtered);
    localStorage.setItem('cart', JSON.stringify(filtered));
  };

  let productPrice = cartItems.map((el) => Number(el.price));

  let totalProductPrice =
    productPrice.length > 0 ? productPrice.reduce((a, b) => a + b, 0) : 0;

  const config = {
    public_key: PUBLIC_KEY,
    tx_ref: reference,
    amount: totalProductPrice,
    currency: 'NGN',
    payment_options: 'card,mobilemoney,ussd',
    customer: {
      email: values?.email || '',
      phone_number: '',
      name: `${values?.firstName} ${values?.lastName}` || '',
    },
    customizations: {
      title: 'Personalized Learning by Edves',
      description: 'Payment for items in cart',
      logo: 'https://st2.depositphotos.com/4403291/7418/v/450/depositphotos_74189661-stock-illustration-online-shop-log.jpg',
    },
  };

  const handleFlutterPayment = useFlutterwave(config);

  const pay = async () => {
    if (values?.school) {
      notification['error']({
        message: 'This is a tutor account, please log in as a student',
      });
      return; // Exit early if the condition is met.
    }

    try {
      let orderData = {
        courses: courseids,
        paymentGateway: 1,
        reference: reference,
      };

      let response = await saveOrders(values.id, orderData, token);

      handleFlutterPayment({
        callback: async (response) => {
          let token = localStorage.getItem('token');

          let verifyResponse = await updateOrder(
            values.id,
            {
              paymentGatewayReference: response.transaction_id,
            },
            token,
            response.tx_ref
          );
        },
        onClose: () => {
          setLoading(false);
          // No redirection here in the onClose function
          localStorage.removeItem('cart');
        },
      });
    } catch (error) {
      if (error.response && error.response.status === 401) {
        let timer = 5; // seconds
        notification['info']({
          message: `Your session has expired or you are not logged in, You will be redirected to login in 10 seconds`,
        });

        const timerInterval = setInterval(() => {
          timer--;
          if (timer === 0) {
            clearInterval(timerInterval);
            setTimeout(() => {
              navigate('/login');
            }, 5000);
          }
        }, 1000);
      } else {
        // Handle other errors
        console.error('An error occurred:', error);
      }
    }
  };
  return (
    <div>
      <Helmet>
        <title>PL by Edves | Cart</title>
      </Helmet>
      <Header />
      <div className='cart-page'>
        <div className='cart-page__title'>
          <h3>Lesson Cart </h3>
          <p> You have {cartItems.length} subjects and topics in your cart</p>
        </div>

        <div className='cart-page__flex'>
          <div className='cart-page__flex__left'>
            {cartItems.length > 0 ? (
              cartItems.map((el) => (
                <div className='cart-page__flex__left__cart-item' key={el.id}>
                  <img src={el.banner} alt='' />
                  <div className='cart-page__flex__left__cart-item__content'>
                    <h3>{el.title}</h3>
                    <p>
                      Offered by{' '}
                      <span style={{ color: '#FEA82F' }}>
                        {el?.school?.name}
                      </span>
                    </p>
                    <div className='cart-page__flex__left__cart-item__content__details'>
                      <p>{el.duration}</p>
                      <svg
                        width='4'
                        height='4'
                        viewBox='0 0 4 4'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <circle cx='2' cy='2' r='2' fill='#D5D4D4' />
                      </svg>

                      <p>{el.topics_count} Topics</p>
                      <svg
                        width='4'
                        height='4'
                        viewBox='0 0 4 4'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <circle cx='2' cy='2' r='2' fill='#D5D4D4' />
                      </svg>

                      <p style={{ color: '#161410' }}>
                        {el?.subject_class?.title}
                      </p>
                    </div>
                    <h4>
                      {el?.currency?.symbol}
                      {Number(el.price).toLocaleString()}
                    </h4>
                  </div>
                  <div
                    className='cart-remove'
                    onClick={() => removeItem(el.id)}
                  >
                    <svg
                      width='10'
                      height='10'
                      viewBox='0 0 10 10'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M9.66683 1.27203L8.72683 0.332031L5.00016 4.0587L1.2735 0.332031L0.333496 1.27203L4.06016 4.9987L0.333496 8.72536L1.2735 9.66537L5.00016 5.9387L8.72683 9.66537L9.66683 8.72536L5.94016 4.9987L9.66683 1.27203Z'
                        fill='#F71E1E'
                      />
                    </svg>

                    <p>Remove</p>
                  </div>
                </div>
              ))
            ) : (
              <div>No Items available in your cart</div>
            )}
          </div>

          <div className='cart-page__flex__right'>
            <p>Total</p>
            <h1>
              {' '}
              {cartItems[0]?.currency?.symbol}
              {totalProductPrice.toLocaleString()}
            </h1>
            <Button
              text={'Proceed'}
              type='submit'
              className='primary-btn'
              width='100%'
              onClick={() => (token ? pay() : navigate('/login?cart=true'))}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
